// extracted by mini-css-extract-plugin
export default {"containerCabinet":"Downloads_containerCabinet__+ttTT"};